import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesMetier} from '@app/core/interfaces';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import {ListActeTableListeRestApiService} from './list-acte-table.liste.rest-api.service';

@Injectable({providedIn: 'root'})
export class ListActeTableListeMetierService implements IRecuperationListeDonneesMetier {
  @Autowired() restApi: ListActeTableListeRestApiService;

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    return this.restApi.requeteRecuperationListeDonnees(data, args);
  }

  recupererMontantActe(data: any, args?: any): Observable<any> | Promise<any> | any {
    return this.restApi.recupererMontantActe(data, args);
  }

  recupererMontantPEC(data: any, args?: any): Observable<any> | Promise<any> | any {
    return this.restApi.recupererMontantPEC(data, args);
  }
}
